import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {matchMediaLGUp} from "../mediaQuery.js";
import {startPageOnTop} from "../utilities.js";

export default function () {
    startPageOnTop();

    /**
     * Section Grid Boot
     */
    (() => {
        /* ==========================================================================
        Boot scale
        ========================================================================== */
        const sectionHero = document.querySelector('.section-hero');
        const gridBootLines = document.querySelector('.grid-boot-lines');
        const parallaxElements = document.querySelectorAll('.section-gray .has-parallax')
        const gridBootLinerImage = document.querySelector('.grid-boot__liner-image');
        const linerImage = document.querySelector('.liner-image');
        const bootImage = document.querySelector('.boot-image');
        const frame = document.querySelector('.section-gray__frame');

        if (sectionHero) {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: sectionHero,
                    start: "top top",
                    toggleActions: "start pause reverse pause",
                    end: "bottom top",
                    scrub: true,
                    pin: true,
                    pinSpacing: false,
                    markers: false,
                    onLeave: () => {
                        gridBootLinerImage?.style.setProperty("--grid-boot-liner-image-opacity", "0");
                        linerImage?.style.setProperty("--liner-image-opacity", "1");
                    },
                    onEnterBack: () => {
                        gridBootLinerImage?.style.setProperty("--grid-boot-liner-image-opacity", "1");
                        linerImage?.style.setProperty("--liner-image-opacity", "0")
                    }
                }
            });

            tl.fromTo('.grid-boot__boot',
                {
                    rotate: "25%",
                    scale: matchMediaLGUp.matches ? "1.8" : "1.6",
                },
                {
                    rotate: "0",
                    scale: "1"
                }
            );

            tl.to(gridBootLines, {
                '--line-width': '97%',
                ease: "power3.out",
            }).to(gridBootLines, {
                '--shadow-width': '97%',
                ease: "power3.out",
            });
        }

        /* Section Gray (inside section hero) */
        const sectionGray = document.querySelector('.section-gray');
        if (sectionGray) {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: '.section-gray',
                    start: 'top top',
                    end: "+=50%",
                    scrub: true,
                    pin: true,
                    markers: false,
                },
            });

            tl.to(linerImage, {
                "--liner-image-clip-path-bottom": "100%"
            });

            tl.to(bootImage, {
                "--boot-image-clip-path-bottom": "0%"
            }, "<");

            tl.to(frame, {
                y: "-75vh"
            }, "<+=0.04");

            tl.to(gridBootLines, {
                '--line-width': '105%',
                '--shadow-width': '105%',
            }, "<");
        }

        const sectionAnatomyGallery = document.querySelector('.section-anatomy__gallery');
        if (sectionAnatomyGallery) {
            ScrollTrigger.create({
                trigger: sectionAnatomyGallery,
                start: "top 20%",
                end: "bottom top",
                markers: false,
                onEnter: () => {
                    ScrollTrigger.refresh();
                    setTimeout(() => sectionAnatomyGallery.dataset.theme = 'dark', 600)
                },
                onEnterBack: () => sectionAnatomyGallery.dataset.theme = 'dark',
                onLeave: () => sectionAnatomyGallery.dataset.theme = 'light',
                onLeaveBack: () => sectionAnatomyGallery.dataset.theme = 'light',
            });
        }

        const anatomyAnimation = document.querySelector('.anatomy-animation');
        const anatomyAnimationItems = anatomyAnimation?.querySelectorAll('.anatomy-animation-item');
        if (anatomyAnimation && anatomyAnimationItems?.length) {
            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: anatomyAnimationItems,
                    start: "top 50%",
                    end: "bottom bottom",
                    toggleAction: "restart pause resume reverse",
                    scrub: true,
                    markers: false,
                }
            });

            timeline.set(anatomyAnimationItems, {
                "--anatomy-animation-item-opacity": "1"
            });

            const gridCol2Span = Math.min(anatomyAnimationItems[0].clientWidth * 0.85, 464);
            timeline.to(anatomyAnimationItems, {
                "--grid-col2-span": `${gridCol2Span}px`
            });

            // Effetto slide up per titolo e sottotitolo in entrata | BEGIN
            const firstItemTitle = anatomyAnimationItems[0]?.querySelector('.anatomy-animation-item__title');
            if (firstItemTitle) {
                const firstTitleMaskHeight = anatomyAnimationItems[0].querySelector('.title-mask').offsetHeight;
                gsap.set(firstItemTitle, {
                    y: firstTitleMaskHeight,
                    opacity: .15,
                });
                timeline.to(firstItemTitle, {
                    y: 0,
                    opacity: 1,
                }, "<");
            }

            const firstItemSubtitle = anatomyAnimationItems[0]?.querySelector('.subtitle-mask .anatomy-animation-item__subtitle');
            if (firstItemSubtitle) {
                const firstSubtitleMaskHeight = anatomyAnimationItems[0].querySelector('.subtitle-mask').offsetHeight;
                gsap.set(firstItemSubtitle, {
                    y: firstSubtitleMaskHeight,
                    opacity: .15,
                });
                timeline.to(firstItemSubtitle, {
                    y: 0,
                    opacity: 1,
                }, "<");
            }
            // Effetto slide up per titolo e sottotitolo in entrata | END

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: anatomyAnimation,
                    start: 'top top',
                    end: `+=${anatomyAnimationItems.length * 500}`,
                    scrub: 1,
                    pin: true,
                    markers: false,
                    onEnter: () => ScrollTrigger.refresh()
                },
            });

            const sizeBar = anatomyAnimationItems[2].querySelector('.anatomy-animation-item__size');
            anatomyAnimationItems.forEach((item, i) => {
                const titleMaskHeight = item.querySelector('.title-mask').offsetHeight;
                const subtitleMaskHeight = item.querySelector('.subtitle-mask').offsetHeight;
                const descriptionMaskHeight = item.querySelector('.description-mask').offsetHeight;
                const prev = anatomyAnimationItems[i - 1];

                if (i === 2) {
                    tl.to(sizeBar,
                        {
                            "--size-opacity" : "1",
                            duration: .15
                        }
                    );
                }

                if (i === 0) {
                    tl.to({}, { duration: 1 }); // pausa iniziale
                    return;
                } else {
                    gsap.set(item.querySelector('.anatomy-animation-item__title'), {
                        y: titleMaskHeight,
                        opacity: .15,
                    });
                    gsap.set(item.querySelector('.subtitle-mask .anatomy-animation-item__subtitle'), {
                        y: subtitleMaskHeight,
                        opacity: .15,
                    });
                    gsap.set(item.querySelector('.anatomy-animation-item__description'), {
                        y: descriptionMaskHeight,
                        opacity: .15,
                    });
                }

                tl.to(
                    prev.querySelector('.anatomy-animation-item__figure'),
                    {
                        "--item-figure-clip-path-bottom": "100%",
                        duration: 1,
                        ease: 'none',
                    },
                    "<"
                );
                tl.to(
                    prev.querySelector('.lines-row__line'),
                    {
                        yPercent: -100,
                        duration: 1,
                        ease: 'none',
                    },
                    "<"
                );

                const textExitTarget = i === 2 ? anatomyAnimationItems[0] : prev;
                const skipTextExit = i === 1;
                const skipTextEntrance = i === 1;

                if (!skipTextExit) {
                    tl.to(
                        textExitTarget.querySelector('.anatomy-animation-item__title'),
                        {
                            y: -(titleMaskHeight * 0.5),
                            opacity: 0,
                            duration: 0.3,
                            ease: 'none',
                        },
                        '<',
                    );
                    tl.to(
                        textExitTarget.querySelector('.subtitle-mask .anatomy-animation-item__subtitle'),
                        {
                            y: -(subtitleMaskHeight * 0.5),
                            opacity: 0,
                            duration: 0.3,
                            ease: 'none',
                        },
                        '<',
                    );
                    tl.to(
                        textExitTarget.querySelector('.anatomy-animation-item__description'),
                        {
                            y: -(descriptionMaskHeight * 0.5),
                            opacity: 0,
                            duration: 0.3,
                            ease: 'none',
                        },
                        '<',
                    );
                }

                if (!skipTextEntrance) {
                    tl.to(
                        item.querySelector('.anatomy-animation-item__title'),
                        { y: 0, opacity: 1, duration: 1, ease: 'none' },
                        '<',
                    );
                    tl.to(
                        item.querySelector('.subtitle-mask .anatomy-animation-item__subtitle'),
                        { y: 0, opacity: 1, duration: 1, ease: 'none' },
                        '<',
                    );
                    tl.to(
                        item.querySelector('.anatomy-animation-item__description'),
                        { y: 0, opacity: 1, duration: 1, ease: 'none' },
                        '<',
                    );
                }

                if (sizeBar) {
                    const dataSize = item.querySelector('.description-container')?.dataset.size;
                    tl.to(
                        sizeBar,
                        {
                            "--size-value": dataSize ? `${dataSize}px` : "1px",
                        },
                        '<',
                    );
                }

                tl.to({}, { duration: 1.5 }); // pausa post-transizione
            });

            const lastItem = anatomyAnimationItems[anatomyAnimationItems.length - 1];
            const lastItemTitle = lastItem.querySelector('.anatomy-animation-item__title');
            const lastItemSubtitle = lastItem.querySelector('.subtitle-mask .anatomy-animation-item__subtitle');

            // Effetto slide up per titolo e sottotitolo in uscita | BEGIN
            if (lastItemTitle) {
                const lastTitleMaskHeight = lastItem.querySelector('.title-mask').offsetHeight;
                tl.to(lastItemTitle, {
                    y: -(lastTitleMaskHeight * 0.5),
                    opacity: 0,
                    duration: 0.3,
                    ease: 'none',
                });
            }

            if (lastItemSubtitle) {
                const lastSubtitleMaskHeight = lastItem.querySelector('.subtitle-mask').offsetHeight;
                tl.to(lastItemSubtitle, {
                    y: -(lastSubtitleMaskHeight * 0.5),
                    opacity: 0,
                    duration: 0.3,
                    ease: 'none',
                }, "<");
            }
            // Effetto slide up per titolo e sottotitolo in uscita | END

            tl.to(
                anatomyAnimationItems,
                {
                    "--grid-col2-span": "0px",
                    duration: 1
                },
            );

            if (sizeBar) {
                tl.to(
                    sizeBar,
                    {
                        "--size-value": "1",
                        duration: ".1s"
                    },
                    '<',
                );
            }
        }

        /* ==========================================================================
        Parallax
        ========================================================================== */
        gsap.set(parallaxElements, {
            opacity: 0,
            y: 50
        })

        parallaxElements.forEach((el) => {
            gsap.to(el, {
                opacity: 1,
                y: 0,
                scrollTrigger: {
                    trigger: el,
                    scrub: true,
                    start: "top bottom",
                    end: "top center",
                },
            });
        });
    })();

    /* ==========================================================================
    Section Grid Videos
    ========================================================================== */
    (() => {
        const sectionContainer = '.section-grid-videos-container'
        const section = '.section-grid-videos'

        const sectionParams = {
            mobile: {
                itemWidth: '100px',
                itemHeight: '450px',
                y: '-70%'
            },
            mdUp: {
                itemWidth: '425px',
                itemHeight: '460px',
                y: '-70%'
            },
            xlUp: {
                itemWidth: '25vw',
                itemHeight: '27vw',
                y: '-70%'
            },
        }

        ScrollTrigger.create({
            trigger: sectionContainer,
            start: 'top bottom',
            once: true,
            onEnter: () => ScrollTrigger.refresh(),
        })

        // Converte un valore CSS di altezza (px, vw, %, ...) in pixel reali a runtime
        const measurePx = (value) => {
            const probe = document.createElement('div');
            probe.style.cssText = `position:absolute; visibility:hidden; pointer-events:none; height:${value};`;
            document.body.appendChild(probe);
            const px = probe.offsetHeight;
            probe.remove();
            return px;
        };

        const gridVideosTl = (obj) => {
            // Altezza reale della griglia finale (3 righe, come da grid-template-rows)
            const gridHeight = measurePx(obj.itemHeight) * 3;

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: sectionContainer,
                    pin: true,
                    start: 'bottom bottom',
                    end: `+=${gridHeight}`,
                    scrub: 3,
                    invalidateOnRefresh: true,
                    markers: false,
                },
            })

            tl.from('.grid-video-content', {
                opacity: 0,
                y: '100%',
                duration: 2
            }).to(section, {
                css: {
                    '--item-width': obj.itemWidth,
                    '--item-height': obj.itemHeight,
                    '--gap': '10px',
                    '--rounded': '1rem',
                },
                duration: 3
            }, '<');

            return tl
        }

        const mm = gsap.matchMedia()

        mm.add(
            {
                mobile: '(max-width: 576px)',
                mdUp: '(min-width: 768px)',
                xlUp: '(min-width: 1400px)',
            },
            (context) => {
                const {mdUp, xlUp} = context.conditions;

                let target = 'mobile'
                if (mdUp) target = 'mdUp'
                if (xlUp) target = 'xlUp'

                gridVideosTl(sectionParams[target])

                return () => gridVideosTl(sectionParams.mobile)
            }
        )
    })();
}
